import parseJSON from './parse-json'

export default parseJSON
